import type {
  CustomValidationRules,
  ValidationSchema,
} from '@wix/editor-elements-corvid-utils';
import { reportError } from '@wix/editor-elements-corvid-utils';
import type {
  IAccordionContainerMapperProps,
  IAccordionContainerPropSDK,
  IRawItem,
} from '../types';

export const uniqueItemIdValidator = (items: Array<IRawItem>) => {
  const invalid = new Set(items.map(item => item.id)).size !== items.length;
  if (invalid) {
    reportError(
      `Accordion items array contains duplicated items. Make sure all items have a unique ID.`,
    );
    return false;
  }
  return true;
};

export const idShouldBePresentWithinInitialItemsValidator = (
  initialItems: Array<IRawItem>,
  newIds: Array<string>,
) => {
  const value = newIds.find(id => !initialItems.some(item => item.id === id));
  if (value) {
    const index = newIds.indexOf(value);
    reportError(
      `Accordion expandedItems array contains a nonexistent item ID: ${value} at index ${index}`,
    );
    return false;
  }
  return true;
};

export const itemWithIdShouldBePresentWithinInitialItemsValidator = (
  initialItems: Array<IRawItem>,
  newItems: Array<IRawItem>,
) => {
  const value = newItems.find(
    ({ id }) => !initialItems.some(item => item.id === id),
  );
  if (value) {
    const index = newItems.indexOf(value);
    reportError(
      `Accordion items array contains a new item not present in the original array: ${JSON.stringify(
        value,
      )} at index ${index}`,
    );
    return false;
  }
  return true;
};

export const customValidators: CustomValidationRules<
  IAccordionContainerMapperProps,
  IAccordionContainerPropSDK
> = {
  items: [uniqueItemIdValidator],
};
export const validationSchema: ValidationSchema = {
  type: ['object'],
  properties: {
    items: {
      type: ['array'],
      items: {
        type: ['object'],
        properties: {
          id: {
            type: ['string'],
          },
          label: {
            type: ['string'],
            minLength: 1,
            maxLength: 120,
          },
        },
        required: ['id', 'label'],
      },
      minLength: 1,
    },
    multipleExpand: {
      type: ['boolean', 'nil'],
    },
    expandedItems: {
      type: ['array', 'nil'],
      items: {
        type: ['string'],
      },
    },
    onItemClicked: {
      type: ['function'],
      args: [{ type: ['function'] }],
    },
  },
};
